import {
  SET_LANGUAGE,
  SET_NOTIFICATIONS_COUNT,
  SET_NOTIFICATIONS_RECEIVED,
  SET_NOTIFICATIONS_REQUESTED, SHOW_SUCCESS_NOTIFICATION, UPDATE_RELATED_JOBS_NOTIFICATIONS_COUNT
} from "../constants/actionTypes";

export const setLanguage = (language) => ({
  type: SET_LANGUAGE,
  payload: {language}
})

export const setNotificationsCount = (notificationsCount) => ({
  type: SET_NOTIFICATIONS_COUNT,
  payload: {notificationsCount}
})

export const setNotificationsReceived = (notificationsReceived) => ({
  type: SET_NOTIFICATIONS_RECEIVED,
  payload: {notificationsReceived}
})

export const setNotificationsRequested = (notificationsRequested) => ({
  type: SET_NOTIFICATIONS_REQUESTED,
  payload: {notificationsRequested}
});

export const showSuccessNotification = (successNotification) => ({
  type: SHOW_SUCCESS_NOTIFICATION,
  payload: successNotification
});

export function updateRelatedJobsNotificationsCount() {
  return {type: UPDATE_RELATED_JOBS_NOTIFICATIONS_COUNT}
}
